module.exports = __webpack_public_path__ + "static/media/calm_slightly-happy.8af075b6.svg";